module.exports = __webpack_public_path__ + "static/media/redness.68328f77.svg";